<template>
  <div class="AddressSelectCom-wrap">
    <el-dialog
      width="900px"
      title="地图选点"
      :visible.sync="IsShowMap"
      :close-on-click-modal="false"
      @close="close"
      append-to-body
      class="mapAddress"
    >
      <div
        class="showMap"
        v-if="IsShowMap"
      >
        <MapAddress :allArea="allArea" @mapArray="mapArray" :addressObj="addressObj"></MapAddress>
      </div>
    </el-dialog>
    <div v-show="false">
      <div id="containerA"></div>
    </div>

  </div>
</template>

<script>
  import MapAddress from "./MapAddress";

  export default {
    name: "CitySelectCom",
    model: {
      prop: "modelVal", //指向props的参数名
      event: "change" //事件名称
    },
    data() {
      return {
        detailAddress: '',//不含省市区的详细地址
        allDetailAddress: '',//含省市区的详细地址
        isMap: false,
        IsShowMap: false,
        currentAddress: "",
        optionProps: {
          value: "no",
          label: "name"
        },
        area:"",
        addressObjTmp: {
          address: "",
          lng: null,
          lat: null,
        },
      };
    },
    props: {
      addressObj: {
        type: Object,
        default:function() {
          return {
            address: "",
            lng: null,
            lat: null,
          }
        }
      },
      modelVal: "",
      isInit: {
        type: Boolean,
        default: false
      },
      allArea: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    computed: {},
    watch: {
      addressObj: {
        handler: function(val) {
          if(val && val.address && val.lng && val.lat) {
            Object.assign(this.addressObjTmp, val)
          }
        },
        immediate: true,
        deep: true,
      },
      detailAddress: {
        handler: function(nVal) {
          if(nVal) {
            this.$emit("customAddr", nVal);
          }
        },
        immediate: true,
        deep: true,
      },
      allDetailAddress: {
        handler: function(nVal) {
          if(nVal) {
            this.$emit("getAllAddress", nVal);
          }
        },
        immediate: true,
        deep: true,
      },
      modelVal: {
        handler: function (nVal) {
          if (nVal) {
            this.currentAddress = nVal;
            if (!this.isMap) {
              this.getDataNode();
            }
            else {
              this.isMap = false;
            }
          } else {
            this.currentAddress = ''
          }
        },
        immediate: true
      },
      currentAddress: {
        handler: function (nVal) {
          this.$emit("change", nVal);
        },
        immediate: true
      }
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
      });
    },
    methods: {
      close() {
        Object.assign(this.addressObj, this.addressObjTmp)
      },
      //自选值
      getDataNode() {
        if(this.$refs['AddressStartPlace']) {
          this.$nextTick(() => {
            var that = this;
            this.isMap = false;
            var objPro = { 
              province: this.currentAddress[0],
              city: this.currentAddress[1],
              district: this.currentAddress[2],
            }; 
            const provinceName = this.getAreaName(this.currentAddress[0], 1)
            const cityName = this.getAreaName(this.currentAddress[1], 2)
            const districtName = this.getAreaName(this.currentAddress[2], 3)
            const addr = `${provinceName}${cityName}${districtName}`;
            var map = new AMap.Map("containerA", {
              resizeEnable: true
            });
            var geocoder = null;
            AMap.plugin("AMap.Geocoder", function () {
              geocoder = new AMap.Geocoder({});
            });
            geocoder.getLocation(addr, function (status, result) {
              if (status === "complete" && result.geocodes.length) {
                that.addressObj.address = '';
                that.addressObj.lng = result.geocodes[0].location.lng;
                that.addressObj.lat = result.geocodes[0].location.lat;
                that.StringOnj(that.currentAddress, that.addressObj, objPro);
              }
              else {
              }
            });
          });
        }
      },
      //获取省市区简称
      getAreaName(no, type) {
        //type：1-省，2-市，3-区
        const allArea = this.allArea;
        if(no && type) {
          for(let i of allArea) {
            if(type === 1 && i.no === no) {
              return i.name
            }
            if(type === 2) {
              for(let j of i.children) {
                if(j.no === no) {
                  return j.name
                }
              }
            }
            if(type === 3) {
              for (let m of i.children) {
                for (let n of m.children) {
                  if(n.no === no) {
                    return n.name
                  }
                }
              }
            }
          }
        } else {
          return ''
        }
      },
      StringOnj(PriArray, addressObj, PriData) {
        const array = [];
        for (var i = 0; i < 3; i++) {
          const obj = {
            value: PriArray[i],
            label:i == 0? PriData["province"]: i == 1? PriData["city"]: i == 2? PriData["district"]: ""
          };
          array.push(obj);
        }
        const objAll = {
          PriArray: PriArray,
          addressObj: addressObj,
          PriData: PriData,
          json: array
        };
        this.$emit("AddressObj", objAll);
      },
      //获取地区数组
      mapArray(data) {
        this.detailAddress = ''
        this.allDetailAddress = ''
        this.isMap = true;
        const array = [];
        for (var i = 0; i < 3; i++) {
          const obj = {
            value: data.PriArray[i],
            label:i == 0? data.PriData["province"]: i == 1? data.PriData["city"]: i == 2? data.PriData["district"]: ""
          };
          array.push(obj);
        }
        data.json = array;
        this.currentAddress = data.PriArray;
        this.$emit("change", data.PriArray);
        //v1.9 处理详细地址---去掉省市区
        let area = ''
        if(
          data.PriData.province === "北京市" ||
          data.PriData.province === "上海市" ||
          data.PriData.province === "天津市" ||
          data.PriData.province === "重庆市" || 
          data.PriData.city==data.PriData.district
        ) {
          this.area = data.PriData.province + data.PriData.district
        } else {
          this.area = data.PriData.province + data.PriData.city + data.PriData.district

        }
        this.detailAddress = data.addressObj.address.replace(this.area, '');
        this.allDetailAddress = data.addressObj.address  //v2.2.0.2 工队发布、工人发布地图选点新增 详细地址全名
        Object.assign(this.addressObjTmp, JSON.parse(JSON.stringify(data.addressObj)))
        this.$emit("AddressObj", data);
        this.IsShowMap = false;
      },
    },
    mixins: [],
    filters: {},
    components: {
      MapAddress
    }
  };
</script>

<style lang="scss" scoped>
  .AddressSelectCom-wrap {
    .AddressMap {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .wd200 {
        width: 180px !important;
      }
      i {
        margin-left: 10px;
        font-size: 18px;
      }
      .mapTime {
        img {
          display: inline-block;
          width: 30px;
          height: 26px;
          vertical-align: middle;
          /*margin-left: 10px;*/
          margin-right: 10px;
        }
      }
    }
  }
</style>
<!--修改外层弹出框的样式-->
<style lang="scss">
  .mapAddress {
    .el-dialog__body {
      padding: 0;
    }
  }
  .CitySelectCom-popover {
    margin-top: -10px !important;
    border-radius: 0 !important;
    padding: 0 !important;
    .select-city-wrap {
      .tabs-wrap {
        margin-top: 5px;
      }
      .el-tabs__item {
        padding: 0 15px 0 0 !important;
        font-size: 12px !important;
        line-height: 28px;
        height: 28px;
      }
      .el-tabs__item:hover .el-tabs__item.is-active {
        color: #0286df !important;
      }
      .el-tabs__header {
        margin: 0 !important;
      }
    }
  }
</style>
